import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface ComposeReviewData {
    abstractId: number;
    agreedToRepurposingContent: boolean | null;
    agreedToSpeakerGuidelines: boolean | null;
    agreedToUsagePermission: boolean | null;
}

export class ComposeReview implements FormValidationModel<ComposeReviewData> {
    public data: ComposeReviewData;
    public rules: yup.Schema<ComposeReviewData>;

    public constructor() {
        this.data = {
            abstractId: 0,
            agreedToRepurposingContent: null,
            agreedToSpeakerGuidelines: null,
            agreedToUsagePermission: null,
        };
        this.rules = yup.object<ComposeReviewData>().shape({
            abstractId: yup.number().required().label("Abstract ID").min(0, "Invalid $label"),
            agreedToRepurposingContent: yup.boolean().nullable(true).required().label("Repurposing of content"),
            agreedToSpeakerGuidelines: yup.boolean()
                .oneOf([true], "You must agree to the speaker guidelines")
                .nullable(true).required().label("Speaker attestation"),
            agreedToUsagePermission: yup.boolean().nullable(true).required().label("Usage permission"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/abstract/ComposeReview.ts